import {Component, OnDestroy, OnInit} from '@angular/core';
import { LoginService } from '../../app-core/service/login.service';
import { Usuario } from '../../app-core/model/cadastros/usuario.model';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import UiSwal from '../../app-core/utils/ui/misc/ui-swal';

@Component({
    selector: 'login',
    template: '',
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
    private authSubscription: Subscription;
    public environment = environment;

    constructor(
        private loginService: LoginService
    ) {
    }

    ngOnInit() {
        const usuarioLogado = this.loginService.getUser();

        if (usuarioLogado && usuarioLogado.roles) {

            // this.loginService.redirectTo('/selecionar-unidade');
            this.loginService.redirectToHome();

            return;
        }

        // O código abaixo só será executado se o usuário chegar aqui sem uma sessão
        this.authSubscription = this.loginService.isAuthenticated$
            .pipe(
                filter(isAuthenticated => isAuthenticated)
            )
            .subscribe(isAuthenticated => {
                if (isAuthenticated) {
                    this.handleAuthentication();
                }
            });

        setTimeout(() => {
            if (!this.loginService.getUser()?.roles) {
                this.loginService.keycloakLoginSSO();
            }
        }, 1500);
    }

    private handleAuthentication(): void {
        this.loginService.doAuth().subscribe({
            next: (autenticado: Usuario) => {
                if (autenticado && autenticado.roles) {
                        this.loginService.setUsuarioLogado(autenticado);
                        this.loginService.redirectToHome();
                } else {
                    this.loginService.logout();
                }
            },
            error: (error) => {
                this.loginService.logout();
            }
        });
    }

    ngOnDestroy() {
        if (this.authSubscription) {
            this.authSubscription.unsubscribe();
        }
    }
}
